module.exports = __webpack_public_path__ + "img/pdf_bg_portada.3a2c38df.png";